module.exports = __webpack_public_path__ + "img/Immigration.a1291037.svg";